export class PromoPageDetails {
    PromoPageRenderingFromSitecore: PromoPageContent;
    PromoPageMetaData: PromoPageMetaData;
    SerializedPromoChildContent: any;
}

export class PromoPageContent {
    Title: string;
    PageDescription: string;
    BodyClass: string;
    SitecoreHtml: string;
    AssetManagementHead: string;
    AssetManagementBottom: string;
    ContentEditorUrl: string;
    PageEditorUrl: string;
    Product: string;
    ProxyRule: string;
    EditorialWarningMessages: string[];
    Layout: string;
    IsEmptyDisclaimerLayoutWithOutStyles: string;
    IsEmptyLayout: string;
    IsCollapsibleContainer: boolean;
    H1Header: string;
    H2Header: string;
}

export class PromoPageMetaData {
    ShowSitecoreNavButtons: boolean;
}
